export enum Environment {
  'none',
  'local',
  'test',
  'development',
  'stage',
  'production'
}

export const environments = {
  none: 'none',
  local: 'local',
  test: 'test',
  development: 'development',
  stage: 'stage',
  production: 'production'
} as const;

export type EnvironmentKeys = keyof typeof environments;
export type Environments = (typeof environments)[EnvironmentKeys];

export const environment = process.env.NEXT_PUBLIC_ENVIRONMENT as Environments;
